import React from "react";
import Mailto from "react-mailto";

// eslint-disable-next-line react/prop-types
export default function Index({ data }) {
	const { email, about } = data.site.siteMetadata;

	return (
		<main className="container container-page">
			<h1>About Me</h1>
			{about.map((paragraph, i) => {
				return <p key={i}>{paragraph}</p>;
			})}
			<p>
				Drop me a line at{" "}
				<Mailto email={email} obfuscate={false}>
					{email}
				</Mailto>.
			</p>
		</main>
	);
}

export const pageQuery = graphql`
	query ContactQuery {
		site {
			siteMetadata {
				about
				email
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/about.js